import * as React from 'react'

import { IconProps } from '../types'

function Refresh(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.78 9.873A6.002 6.002 0 0 0 5.168 12a6 6 0 0 0 11.143 3.091l1.713 1.033a8 8 0 1 1 .699-6.76l.613-.919L21 9.555l-2 3a1 1 0 0 1-1.387.277l-3-2 1.11-1.664 1.057.705Z"
      />
    </svg>
  )
}
export default Refresh
